import { render, staticRenderFns } from "./CancelRepair.vue?vue&type=template&id=0bba53a1&scoped=true&"
import script from "./CancelRepair.vue?vue&type=script&lang=js&"
export * from "./CancelRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba53a1",
  null
  
)

export default component.exports